module.exports = __webpack_public_path__ + "img/dracula-17.05a77883.jpg";